<template> <img src="/images/utilitieshistory.png" width="100%" /> </template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {}
};
</script>
